export class FileTypeConstants {
    public static csv: string = "csv";
    public static txt: string = "txt";
    public static doc: string = "doc";
    public static docx: string = "docx";
    public static pdf: string = "pdf";
    public static xml: string = "xml";

    //Image file types
    public static jpg: string = "jpg";
    public static jpeg: string = "jpeg";
    public static png: string = "png";
    public static gif: string = "gif";
    public static PNG: string = "PNG";

    public static get accceptedImageTypes(): string[] {
        return [this.jpg, this.jpeg, this.png, this.PNG, this.gif];
    }
}